/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/common/sticky/ng2-sticky';
const styles_StickyComponent:any[] = ([] as any[]);
export const RenderType_StickyComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_StickyComponent,data:{}});
export function View_StickyComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_StickyComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'sticky',([] as any[]),
      (null as any),[['window','scroll'],['window','resize'],['window','orientationchange']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('window:scroll' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onChange($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('window:resize' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onChange($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('window:orientationchange' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1).onChange($event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },View_StickyComponent_0,RenderType_StickyComponent)),i0.ɵdid(1,4308992,(null as any),
      0,i1.StickyComponent,[i0.ElementRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const StickyComponentNgFactory:i0.ComponentFactory<i1.StickyComponent> = i0.ɵccf('sticky',
    i1.StickyComponent,View_StickyComponent_Host_0,{zIndex:'sticky-zIndex',width:'sticky-width',
        offsetTop:'sticky-offset-top',offsetBottom:'sticky-offset-bottom',start:'sticky-start',
        stickClass:'sticky-class',endStickClass:'sticky-end-class',mediaQuery:'sticky-media-query',
        parentMode:'sticky-parent',orientation:'sticky-orientation'},{activated:'activated',
        deactivated:'deactivated',reset:'reset'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY29tbW9uL3N0aWNreS9uZzItc3RpY2t5Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY29tbW9uL3N0aWNreS9uZzItc3RpY2t5LnRzIiwibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvc3JjL2FwcC9jb21tb24vc3RpY2t5L25nMi1zdGlja3kudHMuU3RpY2t5Q29tcG9uZW50Lmh0bWwiLCJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9zcmMvYXBwL2NvbW1vbi9zdGlja3kvbmcyLXN0aWNreS50cy5TdGlja3lDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGVudD48L25nLWNvbnRlbnQ+IiwiPHN0aWNreT48L3N0aWNreT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7OzsyQkNBQTs7O29CQ0FBO01BQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSw2REFBQTtNQUFBO0lBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/common/sticky/ng2-sticky.ngfactory.ts